export default __webpack_public_path__ + "static/media/Authentic-Sans-150.82e837b1.woff";